/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'create': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M77.082 72.918V52.082h-4.164v20.836H52.082v4.164h20.836v20.836h4.164V77.082h20.836v-4.164z"/><path pid="1" d="M50 31.25c-10.355 0-18.75 8.395-18.75 18.75v50c0 10.355 8.395 18.75 18.75 18.75h50c10.355 0 18.75-8.394 18.75-18.75V50c0-10.355-8.394-18.75-18.75-18.75H50zm0-4.168h50c12.656 0 22.918 10.262 22.918 22.918v50c0 12.656-10.262 22.918-22.918 22.918H50c-12.656 0-22.918-10.262-22.918-22.918V50c0-12.656 10.262-22.918 22.918-22.918z"/></g>'
  }
})
